import React, { useEffect, useState } from "react";
import ModalComp from "../themes/Model";
import DataGridWithEdit from "../themes/DataGridWithEdit ";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
} from "@mui/material";
import api from "../axiosConfig";
import { useModalContext } from "../ModalContext";
import { getCurrentMonthDatesAsia,currencyFormat } from "../helpers";
import { LoadingButton } from "@mui/lab";
import { GridExpandMoreIcon } from "@mui/x-data-grid";

function EditModal({
  open,
  handleClose,
  setCustomOpenModal,
  editValue,
  callValue,
  monthYear,
  updateRowData,
  rowColumn,
  setCallValue,
  // columns,
  modalName,
  dayLevelButton,
  isDisabled,
  page,
  setInitialCorrectionValue,
  initialCorrectionValue,
  currentCorrectionValue,
  setCurrentCorrectionValue,
  handleOpenModal,
  closeModal,
  baselineRateValue,
  pricelist02,
  setEditValue,
  handleCancelScheme,
  handleCancelClick,
  updateLoading,
  setUpdateLoading,
  loadingRowType,
  setLoadingRowType,
  clearModalFormData,
  setSnackbarAlertMessage,
  setSnackbarAlertSeverity,
  setSnackbarAlertOpen,
  setInitialTotalValue,
  initialTotalValue,
  setCurrentTotalValue,
  currentTotalValue,
  handleOpenContinueModal,
  modalsides,
  dayTotalEditValue,
  monthtotaleditValue,
  type
}) {
  const [correctionCancelButton, setCorrectionCancelButton] = useState(false);
  const [editedTotalRevValue, setEditedTotalRevValue] = useState(null);
  const [isTotalRevEdited, setIsTotalRevEdited] = useState(false);
  const [rows, setRows] = useState([]);
  const [totalRevValue, setTotalRevValue] = useState();
  const [editedMonthOutLook, setEditedMonthOutLook] = useState();

  // console.log(isTotalRevEdited, "isTotalRevEdited");
  // console.log(editedTotalRevValue, "editedTotalRevValue");

  useEffect(() => {
    if (editValue) {
      const correctionEntry = editValue.find(
        (entry) => entry.Request_Type === "Correction"
      );
      setCorrectionCancelButton(correctionEntry);
    }
  }, [editValue]);

  const formatNumber = (value) => {
    if (value === null || value === undefined || value === "0.000000")
      return "";
    const num = Number(value);
    return num === 0 ? "" :currencyFormat(num) //new Intl.NumberFormat("en-US").format(num);
  };

  // const handleTotalRevFocus = (params) => {
  //   setEditedTotalRevValue(params.value);
  //   setIsTotalRevEdited(true);

  //   setRows((prevRows) =>
  //     prevRows.map((row) =>
  //       row.type === "Total"
  //         ? { ...row, revValue: totalRevValue.toFixed(2) }
  //         : row
  //     )
  //   );
  // };

  const columns = [
    {
      field: "type",
      headerName: "Type",
      width: 150,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "ratePercent",
      headerName: "Rate %",
      width: 100,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <div style={{ textAlign: "right", width: "100%" }}>
          {params.value === "0%" || params.value === 0 ? "" : params.value}
        </div>
      ),
    },
    {
      field: "rateValue",
      headerName: "Rate Val",
      width: 100,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        // <div style={{ textAlign: "right", width: "100%" }}>
        //   {params.row.type === "Baseline"
        //     ? formatNumber(baselineRateValue ?? 0)
        //     : params.row.type === "Total"
        //     ? params.value
        //     : params.value === 0
        //     ? ""
        //     : `${params.value}`}
        // </div>

        return (
          <div style={{ textAlign: "right", width: "100%" }}>
            {/* {formatNumber(params.value)} */}
            {params.row.type === "Sub total"
              ? params.value
              : `${formatNumber(params.value) || ""}`}
          </div>
        );
      },
    },
    {
      field: "qtyPercent",
      headerName: "Qty %",
      width: 100,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const value =
          params.value === "0%" || params.value === 0 || params.value === ""
            ? ""
            : `${params.value}%`;

        //      if (params.row.type === "Correction") {
        //     console.log("Correction Qty% Value:", value || params.value);
        //  }

        // Only set initial value once for the "Correction" row
        if (page === "summary" && params.row.type === "Correction") {
          if (initialCorrectionValue === null) {
            // Store the initial value the first time it's set
            const newValue = value || params.value;
            setInitialCorrectionValue(newValue);
            setCurrentCorrectionValue(newValue); // Set for the first time
          }

          if (params.value !== currentCorrectionValue) {
            // Allow for dynamic changes while editing
            setCurrentCorrectionValue(params.value);
          }
        }

        return (
          <div
            style={{
              // backgroundColor:
              //   params.row.type === "Correction" ? "#AEF4EC" : "transparent",
              // fontWeight: params.row.type === "Correction" ? "bold" : "normal",
              width: "100%",
              height: "100%",
              textAlign: "right",
            }}
          >
            {params.row.type === "Total" ? params.value : value}
          </div>
        );
      },
    },

    {
      field: "qtyValue",
      headerName: "Qty",
      width: 100,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <div style={{ textAlign: "right", width: "100%" }}>
          {/* {params.row.type === "Total" ? params.value : `${formatNumber(params.value)}`} */}
          {formatNumber(params.value)}
        </div>
      ),
    },

    {
      field: "revPercent",
      headerName: "Rev %",
      width: 100,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <div style={{ textAlign: "right", width: "100%" }}>
          {" "}
          {params.value === "0%" || params.value === 0 ? "" : params.value}
        </div>
      ),
    },
    // {
    //   field: "revValue",
    //   headerName: "Rev Val",
    //   width: 120,
    //   editable: false,
    //   sortable: false,
    //   disableColumnMenu: true,
    //   renderCell: (params) => (
    //     <div style={{ textAlign: "right", width: "100%" }}>
    //       {formatNumber(params.value)}
    //     </div>
    //   ),
    // },
    {
      field: "revValue",
      headerName: "Rev Val",
      width: 120,
      editable: true,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        if (params.row.type === "Total") {
          // Display the edited value if it exists, otherwise display the calculated value
          const displayValue = isTotalRevEdited
            ? formatNumber(editedTotalRevValue)
            : formatNumber(params.value);

          return (
            // <input
            //   type="text"
            //   value={displayValue}
            //   onClick={() => handleTotalRevFocus(params)}
            //   style={{
            //     backgroundColor: "#AEF4EC",
            //     fontWeight: "bold",
            //     width: "100%",
            //     height: "100%",
            //     textAlign: "right",
            //     border: "none",
            //     outline: "none",
            //   }}
            // />
            <div
              style={{
                backgroundColor: "#AEF4EC",
                fontWeight: "bold",
                width: "100%",
                height: "100%",
                textAlign: "right",
              }}
            >
              {displayValue}
            </div>
          );
        }
        return (
          <div style={{ textAlign: "right", width: "100%" }}>
            {params.value === "0" || params.value === 0 || params.value === ""
              ? ""
              : `${formatNumber(params.value)}`}
          </div>
        );
      },
    },
    {
      field: "cost",
      headerName: "Cost",
      width: 100,
      editable: false,
      sortable: false,
      disableColumnMenu: true,

      renderCell: (params) => (
        <div style={{ textAlign: "right", width: "100%" }}>
          {/* {formatNumber(params.value)}
           */}
          {params.value === "0%" || params.value === 0 ? "" : params.value}
        </div>
      ),
    },
    {
      field: "Actions",
      headerName: "Actions",
      width: 220,
      editable: false,
      sortable: false,
      disableColumnMenu: true,

      renderCell: (params) => {
        let pricelist;
        if (page === "dayleveledit" || page === "daylevelchanneledit") {
          pricelist = callValue?.Pricelist;
        } else {
          pricelist = rowColumn?.includes("Pricelist")
            ? callValue?.Pricelist
            : "";
        }

        const checkRequestTypes = (data) => {
          if (!Array.isArray(data)) {
            return {
              hasOnInv: false,
              hasOffInvoice: false,
              hasVisibility: false,
            };
          }

          const hasOnInv = data.some((item) => item.Request_Type === "OnInv");
          const hasOffInvoice = data.some(
            (item) => item.Request_Type === "OffInv"
          );
          const hasVisibility = data.some(
            (item) => item.Request_Type === "Visibility"
          );

          return { hasOnInv, hasOffInvoice, hasVisibility };
        };

        const requestTypeFlags = checkRequestTypes(editValue || []);

        const isCreateDisabled =
          (params.row.type === "On Invoice" &&
            (requestTypeFlags.hasOffInvoice ||
              requestTypeFlags.hasVisibility)) ||
          (params.row.type === "Off Invoice" &&
            (requestTypeFlags.hasOnInv || requestTypeFlags.hasVisibility)) ||
          (params.row.type === "Visibility" &&
            (requestTypeFlags.hasOnInv || requestTypeFlags.hasOffInvoice));

        if (pricelist) {
          if (
            params.row.type === "On Invoice" ||
            params.row.type === "Off Invoice" ||
            params.row.type === "Visibility"
          ) {
            const hasValues =
              params.row.rateValue ||
              params.row.qtyValue ||
              params.row.revValue;

            return (
              <div
                style={{
                  display: "flex",
                  textAlign: "right",
                  width: "var(--width)",
                }}
              >
                {!hasValues && (
                  <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      handleOpenModal(params.row);
                      // setSelectedSchemeType(params.row.type)
                      closeModal(false);
                      if (!hasValues) {
                        clearModalFormData();
                      }
                    }}
                    disabled={isCreateDisabled}
                    style={{
                      fontSize: "10px",
                      backgroundColor: isCreateDisabled
                        ? "#16a69580"
                        : "#16a695",
                      cursor: isCreateDisabled ? "not-allowed" : "pointer",
                      color: "white",
                      marginRight: "8px",
                    }}
                  >
                    {hasValues ? "" : "Create"}
                  </Button>
                )}
                {!hasValues && (
                  <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      handleOpenContinueModal(params.row);
                      // setSelectedSchemeType(params.row.type)
                      closeModal(false);
                      if (!hasValues) {
                        clearModalFormData();
                      }
                    }}
                    disabled={isCreateDisabled}
                    style={{
                      fontSize: "10px",
                      backgroundColor: isCreateDisabled
                        ? "#16a69580"
                        : "#16a695",
                      cursor: isCreateDisabled ? "not-allowed" : "pointer",
                      color: "white",
                      marginRight: "8px",
                    }}
                  >
                    Continue
                  </Button>
                )}
                <LoadingButton
                  size="small"
                  variant="contained"
                  color="error"
                  loading={loadingRowType === params.row.type}
                  loadingPosition="end"
                  disabled={!hasValues}
                  onClick={() => {
                    handleCancelScheme(params.row.type);
                    setLoadingRowType(params.row.type);
                  }}
                  style={{
                    fontSize: "10px",
                    backgroundColor:
                      loadingRowType === params.row.type ? "#D32F2F80" : "",
                    paddingRight:
                      loadingRowType === params.row.type ? "35px" : "",
                    color: loadingRowType === params.row.type ? "#fff" : "",
                    // opacity: !hasValues ? 0.5 : 1,
                    marginRight: "8px",
                    minWidth: loadingRowType === params.row.type ? "36px" : "",
                    paddingRight:
                      loadingRowType === params.row.type ? "28px" : "",
                    // padding: "4px 10px",
                  }}
                >
                  {!loadingRowType || loadingRowType !== params.row.type
                    ? "Cancel"
                    : "Cancel"}
                </LoadingButton>
              </div>
            );
          }
        }

        if (params.row.type === "Correction") {
          const hasValues =
            params.row.qtyPercent || params.row.qtyValue || params.row.revValue;

          // const hasCorrectionValue = !!callValue?.btg_correction;

          // const initialHasValues = !!(
          //   params.row.qtyPercent ||
          //   params.row.qtyValue ||
          //   params.row.revValue
          // );

          // const isButtonDisabled = !hasCorrectionValue || !initialHasValues;

          return (
            <div
              style={{
                display: "flex",
                textAlign: "right",
                width: "var(--width)",
              }}
            >
              <LoadingButton
                size="small"
                variant="contained"
                color="error"
                disabled={!correctionCancelButton}
                loading={updateLoading}
                loadingPosition="end"
                onClick={() => {
                  handleCancelClick(false);
                }}
                style={{
                  fontSize: "10px",
                  backgroundColor: updateLoading ? "#D32F2F80" : "",
                  paddingRight: updateLoading ? "35px" : "",
                  opacity: !correctionCancelButton ? 0.5 : 1,
                  marginRight: "8px",
                  color: updateLoading ? "#fff" : "",
                  transition: "all 0.3s ease",
                }}
              >
                Cancel
              </LoadingButton>
            </div>
          );
        }

        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "var(--width)",
            }}
          >
            <span style={{ color: "#888888", padding: "15px" }}></span>
          </div>
        );
      },
    },
  ];

  let pricelist;
  if (page === "dayleveledit" || page === "daylevelchanneledit") {
    
    pricelist = callValue?.Pricelist??"";
  } else {
    pricelist = rowColumn?.includes("Pricelist") ? callValue?.Pricelist : "";
  }

  const modalWidth = pricelist ? "1090px" : "1090px";

  const commonStyle = {
    display: "flex",
    fontSize: "12px",
    flexDirection: "column",
    marginTop: "0",
  };

  //view more details
  const tableData = [
    {
      label: "",
      children: [
        {
          label: "",
          children: [
            { label: "M2", value: callValue?.M2 },
            { label: "M1", value: callValue?.M1 },
            { label: "AOP", value: callValue?.AOP_Figure },
          ],
        },
      ],
    },
    {
      label: "MTD",
      children: [
        {
          label: "Plan",
          children: [
            { label: "Baseline", value: callValue?.mtd_baseline },
            { label: "Correction", value: callValue?.mtd_correction },
            { label: "On Inv", value: callValue?.mtd_oninv },
            { label: "Off Inv", value: callValue?.mtd_offinv },
            { label: "Target", value: callValue?.mtd_target },
          ],
        },
        {
          label: "Actual",
          children: [{ label: "Actual", value: callValue?.mtd_actual }],
        },
      ],
    },
    {
      label: "BTG",
      children: [
        {
          label: "Plan",
          children: [
            { label: "Baseline", value: callValue?.btg_baseline },
            { label: "Correction", value: callValue?.btg_correction },
            { label: "On Inv", value: callValue?.btg_oninv },
            { label: "Off Inv", value: callValue?.btg_offinv },
            { label: "Plan", value: callValue?.btg_plan },
          ],
        },
      ],
    },
    {
      label: "",
      children: [
        {
          label: "",
          children: [{ label: "Current Plan", value: callValue?.btg_target }],
        },
      ],
    },
    {
      label: "Full Month",
      children: [
        {
          label: "",
          children: [
            { label: "Month Target", value: callValue?.month_target },
            { label: "Outlook", value: callValue?.month_outlook },
          ],
        },
      ],
    },
    {
      label: "",
      children: [
        {
          label: " M Discount Cost Plan ",
          children: [
            {
              label: "OnInv",
              value: callValue?.["M Discount OnInv Plan"],
            },
            {
              label: "OffInv",
              value: callValue?.["M Discount OffInv Plan"],
            },
            {
              label: "Visibility",
              value: callValue?.["M Discount Visibility Plan"],
            },
          ],
        },
      ],
    },
    {
      label: "",
      children: [
        {
          label: "M Discount Cost Act",
          children: [
            {
              label: "OnInv",
              value: callValue?.["M Discount OnInv Act"],
            },
            {
              label: "OffInv",
              value: callValue?.["M Discount OffInv Act"],
            },
            {
              label: "Visibility",
              value: callValue?.["M Discount Visibility Act"],
            },
          ],
        },
      ],
    },
    {
      label: "",
      children: [
        {
          label: "M-1 Discount Cost Plan",
          children: [
            {
              label: "OnInv",
              value: callValue?.["M-1 Discount OnInv Plan"],
            },
            {
              label: "OffInv",
              value: callValue?.["M-1 Discount OffInv Plan"],
            },
            {
              label: "Visibility",
              value: callValue?.["M-1 Discount Visibility Plan"],
            },
          ],
        },
      ],
    },
    {
      label: "",
      children: [
        {
          label: "M-1 Discount Cost Act",
          children: [
            {
              label: "M-1 Discount OnInv Act",
              value: callValue?.["M-1 Discount OnInv Act"],
            },
            {
              label: "M-1 Discount OffInv Act",
              value: callValue?.["M-1 Discount OffInv Act"],
            },
            {
              label: "M-1 Discount Visibility Act",
              value: callValue?.["M-1 Discount Visibility Act"],
            },
          ],
        },
      ],
    },
  ];

  const formContent = (
    <>
      {dayLevelButton && (
        <Accordion
          sx={{
            padding: "0",
          }}
        >
          <AccordionSummary
            sx={{
              padding: "0 10px",
            }}
            expandIcon={<GridExpandMoreIcon />}
          >
            <p
              style={{
                fontSize: "13px",
                fontWeight: 600,
                margin: 0,
              }}
            >
              View More Details
            </p>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              padding: "0 10px 8px 0",
            }}
            o
          >
            <TableContainer
              // component={Paper}
              className="scrollable-div"
              style={{
                display: "flex",
                gap: "10px",
                overflowX: "auto",
                whiteSpace: "nowrap",
                maxWidth: "1060px",
                minWidth: "1060px",
              }}
            >
              <Table>
                <TableBody>
                  {/* Top-Level Header Row */}
                  <TableRow>
                    {tableData.map((item, index) =>
                      item.children ? ( // If the item has children (MTD group)
                        <TableCell
                          key={index}
                          colSpan={item.children.reduce(
                            (acc, curr) => acc + curr.children.length,
                            0
                          )} // Span across all nested children
                          style={{
                            fontSize: "12px",
                            textAlign: "center",
                            fontWeight: "bold",
                            backgroundColor: "#f5f5f5",
                            border: "1px solid #ddd",
                          }}
                        >
                          {item.label}
                        </TableCell>
                      ) : (
                        // Render non-grouped items
                        <TableCell
                          key={index}
                          style={{
                            textAlign: "center",
                            fontWeight: "bold",
                            backgroundColor: "#f5f5f5",
                            border: "1px solid #ddd",
                          }}
                        >
                          {item.label}
                        </TableCell>
                      )
                    )}
                  </TableRow>

                  {/* Second-Level Sub-Label Row */}
                  <TableRow>
                    {tableData.map((item, index) =>
                      item.children ? ( // If the item has children (MTD group)
                        item.children.map((child, childIndex) => (
                          <TableCell
                            key={childIndex}
                            colSpan={child.children.length} // Span across all nested children
                            style={{
                              fontSize: "12px",
                              textAlign: "center",
                              fontWeight: "bold",
                              backgroundColor: "#f5f5f5",
                              border: "1px solid #ddd",
                            }}
                          >
                            {child.label}
                          </TableCell>
                        ))
                      ) : (
                        // Render empty cells for non-grouped items
                        <TableCell
                          key={index}
                          style={{
                            textAlign: "center",
                            border: "1px solid #ddd",
                          }}
                        ></TableCell>
                      )
                    )}
                  </TableRow>

                  {/* Third-Level Sub-Label Row */}
                  <TableRow>
                    {tableData.map((item, index) =>
                      item.children ? ( // If the item has children (MTD group)
                        item.children.flatMap((child) =>
                          child.children.map((nestedChild, nestedIndex) => (
                            <TableCell
                              key={nestedIndex}
                              style={{
                                fontSize: "12px",
                                textAlign: "center",
                                fontWeight: "bold",
                                backgroundColor: "#f5f5f5",
                                border: "1px solid #ddd",
                              }}
                            >
                              {nestedChild.label}
                            </TableCell>
                          ))
                        )
                      ) : (
                        // Render empty cells for non-grouped items
                        <TableCell
                          key={index}
                          style={{
                            textAlign: "center",
                            border: "1px solid #ddd",
                          }}
                        ></TableCell>
                      )
                    )}
                  </TableRow>

                  {/* Value Row */}
                  <TableRow>
                    {tableData.map((item, index) =>
                      item.children ? ( // If the item has children (MTD group)
                        item.children.flatMap((child) =>
                          child.children.map((nestedChild, nestedIndex) => (
                            <TableCell
                              key={nestedIndex}
                              style={{
                                textAlign: "center",
                                minWidth: "120px",
                                padding: "10px",
                                fontSize: "12px",
                                border: "1px solid #ddd",
                              }}
                            >
                              <div
                                style={{
                                  marginTop: "5px",
                                  color: nestedChild.value ? "black" : "red",
                                }}
                              >
                                {nestedChild.value ?? "--"}
                              </div>
                            </TableCell>
                          ))
                        )
                      ) : (
                        // Render non-grouped items
                        <TableCell
                          key={index}
                          style={{
                            textAlign: "center",
                            minWidth: "120px",
                            padding: "10px",
                            fontSize: "12px",
                            border: "1px solid #ddd",
                          }}
                        >
                          <div
                            style={{
                              marginTop: "5px",
                              color: item.value ? "black" : "red",
                            }}
                          >
                            {item.value ?? "--"}
                          </div>
                        </TableCell>
                      )
                    )}
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>
      )}
      <div>
        <DataGridWithEdit
          open={open}
          handleClose={handleClose}
          editValue={editValue}
          callValue={callValue}
          monthYear={monthYear}
          updateRowData={updateRowData}
          rowColumn={rowColumn}
          setCallValue={setCallValue}
          setCustomOpenModal={setCustomOpenModal}
          columns={columns}
          dayLevelButton={dayLevelButton}
          disabled={isDisabled}
          page={page}
          pricelist02={pricelist02}
          setSnackbarAlertMessage={setSnackbarAlertMessage}
          setSnackbarAlertSeverity={setSnackbarAlertSeverity}
          setSnackbarAlertOpen={setSnackbarAlertOpen}
          editedTotalRevValue={editedTotalRevValue}
          setEditedTotalRevValue={setEditedTotalRevValue}
          setIsTotalRevEdited={setIsTotalRevEdited}
          isTotalRevEdited={isTotalRevEdited}
          rows={rows}
          setRows={setRows}
          totalRevValue={totalRevValue}
          setTotalRevValue={setTotalRevValue}
          setEditedMonthOutLook={setEditedMonthOutLook}
          type={type}
        />
      </div>
    </>
  );

  const getFormattedValue = () => {
    // Base value calculation
    let baseValue =
      editedMonthOutLook !== undefined
        ? parseInt(editedMonthOutLook)
        : callValue?.month_outlook
        ? parseInt(callValue.month_outlook)
        : "No data available";

    // Return immediately if baseValue is invalid
    if (baseValue === "No data available") {
      return baseValue;
    }

    // If modalName is "Edit Summary", add the "Actual" Sales value
    if (modalName === "Edit Summary" && Array.isArray(editValue)) {
      const actualSales = parseInt(
        editValue.find((item) => item.Request_Type === "Actual")?.Sales
      );

      // Only add actualSales if it's a valid number
      if (!isNaN(actualSales)) {
        const totalValue = baseValue + actualSales;
        return formatNumber(totalValue);
      }
    }

    return formatNumber(baseValue); // Return formatted baseValue if no actualSales
  };
  const getFormattedValueDayTotal = () => {
    if (editedMonthOutLook !== undefined) {
      const valuesDiff = callValue[rowColumn] - editedMonthOutLook;
      const dayTotalValue = valuesDiff < 0
        ? dayTotalEditValue - valuesDiff
        : dayTotalEditValue + valuesDiff;

      const baseValue = dayTotalValue !== undefined
        ? parseInt(dayTotalValue)
        : "No data available";

      return baseValue === "No data available"
        ? baseValue
        : formatNumber(baseValue);
    }

    return formatNumber(0);
  };
  // console.log(getFormattedValue, "getFormattedValue");
  const getFormattedValueMonthTotal = () => {
    
   if (editedMonthOutLook !== undefined) {
      const valuesDiff = callValue[rowColumn] - editedMonthOutLook;
      const dayTotalValue = valuesDiff < 0
        ? monthtotaleditValue - valuesDiff
        : monthtotaleditValue + valuesDiff;

      const baseValue = dayTotalValue !== undefined
        ? parseInt(dayTotalValue)
        : "No data available";

      return baseValue === "No data available"
        ? baseValue
        : formatNumber(baseValue);
    }

    return formatNumber(0);
  };
  return (
    <>
      <ModalComp
        open={open}
        setCustomOpenModal={setCustomOpenModal}
        handleClose={handleClose}
        title={
          <>
            <div
              style={{
                display: "flex",
                gap: "40px",
                flexDirection: "row",
                alignItems: "flex-end",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <p
                  style={{
                    fontSize: "18px",
                    fontWeight: 600,
                    margin: "0",
                  }}
                >
                  {modalName}
                </p>
                <span
                  style={{
                    fontSize: "14px",
                  }}
                >
                  {callValue?.Warehouse}, {callValue?.OutletType}
                  {pricelist && `, ${pricelist}`}, {callValue?.Product_Name}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                }}
              >
                <p
                  style={{
                    fontSize: "14px",
                    fontWeight: 600,
                    margin: "0",
                  }}
                >
                 {modalsides !== undefined ? modalsides : 'Month Outlook'}
                </p>
                <span
                  style={{
                    fontSize: "14px",
                  }}
                >
                  {getFormattedValue()}
                </span>
                {dayTotalEditValue !== undefined ? (
                  <>
                    <p
                      style={{
                        fontSize: "14px",
                        fontWeight: 600,
                        margin: "0",
                      }}
                    >
                      Day Total
                    </p>
                    <span
                      style={{
                        fontSize: "14px",
                      }}
                    >
                      {getFormattedValueDayTotal()}
                    </span>
                  </>
                ) : (
                  ""
                )}
                {monthtotaleditValue !== undefined ? (
                  <>
                    <p
                      style={{
                        fontSize: "14px",
                        fontWeight: 600,
                        margin: "0",
                      }}
                    >
                      Month Total
                    </p>
                    <span
                      style={{
                        fontSize: "14px",
                      }}
                    >
                      {getFormattedValueMonthTotal()}
                    </span>
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
          </>
        }
        modalContent={formContent}
        // onSave={handleSave}
        datePickerStyle={{ width: "48%", margin: "5px" }}
        themeStyles={{
          boxStyle: {
            width: "fit-content",
            height: "auto",
            margin: "auto",
            marginTop: "80px",
          },
          titleStyle: {
            color: "#000",
            backgroundColor: "#F4F4F4",
            padding: "20px",
            position: "sticky",
            top: 0,
            zIndex: 10,
          },
          fieldStyle: { width: "100%", marginTop: "20px" },
          actionButtonContainerStyle: {
            padding: "0",
          },
          modalContentStyle: {
            paddingTop: "20px !important",
          },
        }}
      />
    </>
  );
}

export default EditModal;
